<template>
  <div>
    <GfBeneficairySearch
      v-if="ready"
      :event-campaign-id="store.state.selected_event.EventCampaignId" 
      :external="external"
      :region="store.state.region"
      :api-domain="store.state.apiDomain"
      @selected="selected"
    />
  </div>
</template>
<script>
import GfBeneficairySearch from '@gf/gf-beneficiary-search-vue-3'
import GfAnalyticsMixin from '../inc/GfAnalyticsMixin.vue';
import store from '../../store/store';

export default {
  components: {GfBeneficairySearch},
  mixins: [GfAnalyticsMixin],
  data() {
    return {
      store,
      ready: false,
      external: {        
        id: store.state.externalId,
        type: store.state.referrer
      }
    }
  },

  mounted() {    
    this.$nextTick(() => this.ready = true);
  },

  methods:{
    selected(params) {
      this.$gfLogger.logInfo("charity.onSelected(), params: ", params);
      this.stage(params.beneficiaryId, params.beneficiaryName, params.beneficiaryImagePath);
      
      this.analytics({
        'event': 'create_page',
        'createType': 'team', 
        'stepNumber': '2 of 4',
        'stepName': 'select cause',
        'causeName': params.beneficiaryName
      }); 
    },

    stage(beneficiaryId, beneficiaryName, beneficiaryImagePath){            
      this.store.commit('change_Beneficiary', { 
        beneficiaryId : beneficiaryId, 
        BeneficiaryName: beneficiaryName, 
        BeneficiaryImagePath: beneficiaryImagePath, 
        Router_Name: this.$route.name
      });

      if(this.store.state.selected_charity != '' && this.store.state.selected_event != ''){
        this.$router.push({name: 'complete_team' });
      }
      else {
        this.$router.push({name: 'Event_team' });
      }
    }
  }  
}
</script>
